import cn from 'classnames'
import { FC, ReactNode } from 'react'

import styles from './BusinessPrioritiesHeader.module.scss'

interface IBusinessPrioritiesHeaderProps {
  title: ReactNode
  subtitle?: ReactNode
  actions?: ReactNode
  className?: string
}

export const BusinessPrioritiesHeader: FC<IBusinessPrioritiesHeaderProps> = ({
  title,
  subtitle,
  actions,
  className,
}) => {
  return (
    <div className={cn(styles.header, className)}>
      <div className={styles.titleBlock}>
        <div className={styles.title}>{title}</div>
        {subtitle && <div className={styles.subtitle}>{subtitle}</div>}
      </div>

      {actions && <div className={styles.actions}>{actions}</div>}
    </div>
  )
}

BusinessPrioritiesHeader.displayName = 'BusinessPrioritiesHeader'

export default BusinessPrioritiesHeader
